import { makeStyles } from 'tss-react/mui';

export const usePreVideoStyles = makeStyles()((theme) => ({
  enterSessionBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  clientStatus: {
    fontSize: 16,
    fontWeight: 300,
  },
  wrapper: {
    maxWidth: 600,
  },
  videoSelect: {
    marginBottom: '5px',
  },
  detailsBlock: {
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  timeRange: {
    fontWeight: 300,
    fontSize: 20,
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    marginBottom: 8,
  },
  headTitle: {
    color: theme.palette.darkSlate.main,
    fontWeight: 'bold',
    fontSize: 34,
  },
  infoCard: {
    maxWidth: 500,
    width: '100%',
    margin: '32px 0',
    marginBottom: theme.spacing(2),
  },
  userName: {
    width: 'max-content',
    fontWeight: 600,
  },
  patientText: {
    fontWeight: 300,
    fontSize: 16,
    color: '#7c7c7c',
    order: 2,
    marginTop: '4px',
  },
  textIcon: {
    height: 'min-content',
    marginTop: 15,
  },
  joinButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '8px 22px',
    backgroundColor: '#57807D',
    borderRadius: 0,
    '& > span': {
      color: 'white',
      fontWeight: 300,
      fontSize: 15,
    },
  },
  devicesFirstRowContainer: {
    display: 'flex',
  },

  avatar: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  outlineButton: {
    color: theme.palette.text.secondary,
  },
  username: {
    fontWeight: 450,
  }
}));
